module.exports = __webpack_public_path__ + "img/图片13.d913e6eb.png";